import GeoJSON from "ol/format/GeoJSON.js";

function featureToGeojson(feature) {
  return new GeoJSON().writeFeature(feature, {
    dataProjection: 'EPSG:27700',
    featureProjection: 'EPSG:27700'
  });
}

function geojsonToFeature(geojson){
  return new GeoJSON().readFeatures(geojson, {
    dataProjection: 'EPSG:27700',
    featureProjection: 'EPSG:27700'
  });
}

export {
  featureToGeojson, geojsonToFeature
}
